// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"725bfc15","320":"725bfc15","668":"0ee282d6"}[chunkId] + ".chunk.css";
};